import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Col, Form, Pagination, Row } from "react-bootstrap";
import Spinner1 from "../components/common/spinners";
import LabCartModal from "../components/modals/LabCartModal";
import useManageLabRequests from "../hooks/patientDashboard/usemanageLabrequests";
import LabCard from "../components/card/labCard";
import useProfileStore from "../store/patient/profileStore";
import LabCartSideBar from "../components/modals/LabCartSideBar";

const LabMart = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = React.useState(currentSkin);
  const [show, setShow] = React.useState(false);
  const [cartItems, setCartItems] = React.useState([]);
  const { handleFechAllTest, handleQueryTest, loading, labs } = useManageLabRequests();
  const { profile } = useProfileStore();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    handleFechAllTest();
  }, []);

  const openModal = () => {
    setShow(true);
  };

  const addToCart = (lab, carted) => {
    setCartItems((prev) => {
      if (carted) {
        return prev.filter((item) => item.id !== lab.id);
      }

      return [...prev, { ...lab, quantity: 1 }];
    });
  };

  const switchSkin = (mode) => {
    if (mode === "dark") {
      const btnWhite = document.getElementsByClassName("btn-white");

      for (const btn of btnWhite) {
        btn.classList.add("btn-outline-primary");
        btn.classList.remove("btn-white");
      }
      return;
    }

    const btnOutlinePrimary = document.getElementsByClassName("btn-outline-primary");

    for (const btn of btnOutlinePrimary) {
      btn.classList.remove("btn-outline-primary");
      btn.classList.add("btn-white");
    }
  };

  switchSkin(skin);
  React.useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const updateQuantity = (id, newQuantity) => {
    setCartItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, quantity: newQuantity } : item))
    );
  };

  const testsCount = Array.isArray(labs) ? labs.length : 0;
  const totalEstimate = cartItems.reduce(
    (sum, item) => sum + ((item?.serviceCost?.tariff || 0) * (item?.quantity || 1)),
    0
  );

  return (
    <React.Fragment>
      <section className="labmart-hero">
        <div className="labmart-hero-copy">
          <span className="labmart-kicker">Diagnostics</span>
          <h2>Lab Mart</h2>
          <p>
            Search, review, and request tests in a calmer workflow designed to make
            diagnostics feel clear instead of clinical and cluttered.
          </p>
        </div>

        <div className="labmart-hero-stats">
          <div className="labmart-stat">
            <small>Available Tests</small>
            <strong>{testsCount}</strong>
          </div>
          <div className="labmart-stat">
            <small>Selected</small>
            <strong>{cartItems.length}</strong>
          </div>
          <div className="labmart-stat">
            <small>Estimated Total</small>
            <strong>
              {totalEstimate.toLocaleString("en-NG", {
                style: "currency",
                currency: "NGN",
              })}
            </strong>
          </div>
        </div>
      </section>

      <Row className="g-4 align-items-start">
        <Col xl={9}>
          <Card className="card-event labmart-shell">
            <Card.Body className="p-3 p-lg-4">
              <div className="labmart-toolbar">
                <div className="labmart-toolbar-copy">
                  <div className="divider divider-start fw-medium mb-2">
                    <span>Request a Lab Test</span>
                  </div>
                  <h5 className="mb-1">Choose tests with confidence</h5>
                  <p className="mb-0">
                    Search by test name and add what you need to your request cart.
                  </p>
                </div>

                <div className="labmart-toolbar-actions">
                  <div className="labmart-search">
                    <Form.Control
                      type="text"
                      placeholder="Search for a lab test"
                      value={searchTerm}
                      onChange={(event) => {
                        const value = event.target.value;
                        setSearchTerm(value);
                        handleQueryTest(value, profile?.hmo?.id);
                      }}
                    />
                  </div>

                  <Button onClick={openModal} variant="" className="btn-white labmart-cart-btn">
                    <i className="ri-shopping-cart-line"></i>
                    <span>Open Cart</span>
                    {cartItems.length > 0 && (
                      <Badge bg="success" pill>
                        {cartItems.length}
                      </Badge>
                    )}
                  </Button>
                </div>
              </div>

              <div className="labmart-results-meta">
                <span>{testsCount} test options available</span>
                <span>Showing the first 20 results for a faster browse</span>
              </div>

              <Row sm={1} md={2} xl={3} lg={3} className="g-3">
                {loading && searchTerm === "" ? (
                  <div className="w-100 d-flex justify-content-center py-5">
                    <Spinner1 />
                  </div>
                ) : testsCount > 0 ? (
                  labs.slice(0, 20).map((lab) => {
                    const cartedItem = cartItems.find((item) => item?.id === lab.id);
                    return (
                      <LabCard
                        key={lab?.id}
                        lab={lab}
                        carted={!!cartedItem}
                        addToCart={addToCart}
                        updateQuantity={updateQuantity}
                        quantity={cartedItem ? cartedItem.quantity : 1}
                      />
                    );
                  })
                ) : (
                  <div className="labmart-empty">
                    <i className="ri-flask-line"></i>
                    <h6>No lab tests found</h6>
                    <p>Try a different search term or clear the filter to see more results.</p>
                  </div>
                )}
              </Row>

              <div className="w-100 d-flex justify-content-end mt-4">
                <Pagination className="labmart-pagination mb-0">
                  <Pagination.First />
                  <Pagination.Prev />
                  <Pagination.Next />
                  <Pagination.Last />
                </Pagination>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xl={3}>
          <div className="labmart-cart-panel">
            <div className="labmart-cart-panel-head">
              <small>Request Cart</small>
              <strong>{cartItems.length} item(s)</strong>
            </div>
            <LabCartSideBar
              setCartItems={setCartItems}
              setShow={setShow}
              show={show}
              cartItems={cartItems}
            />
          </div>
        </Col>
      </Row>

      <LabCartModal setCartItems={setCartItems} setShow={setShow} show={show} cartItems={cartItems} />
    </React.Fragment>
  );
};

export default LabMart;
